// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgStandbyUseIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M22 9c0 .55-.45 1-1 1h-3v1c0 .55-.45 1-1 1h-2c-2.21 0-4-1.79-4-4H7c-1.65 0-3 1.35-3 3s1.35 3 3 3h10c2.21 0 4 1.79 4 4s-1.79 4-4 4c-.55 0-1-.45-1-1s.45-1 1-1c1.1 0 2-.9 2-2s-.9-2-2-2H7c-2.76 0-5-2.24-5-5s2.24-5 5-5h4c0-2.21 1.79-4 4-4h2c.55 0 1 .45 1 1v1h3c.55 0 1 .45 1 1s-.45 1-1 1h-3v2h3c.55 0 1 .45 1 1m-9 11h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1m-9 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1m4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1" />
  </g>
);
export default SvgStandbyUseIcon;
SvgStandbyUseIcon.displayName = 'SvgStandbyUseIcon';
